import { useTranslation } from "react-i18next"

import { EmailVerificationPageModel } from "../EmailVerificationPage"
import { EmailVerificationPageViewProps } from "../EmailVerificationPageView"

export function useEmailVerificationPageViewModel({
  navigateToHomepage
}: EmailVerificationPageModel): EmailVerificationPageViewProps {
  const { t } = useTranslation()

  return {
    headline: t("EmailVerificationPage.Headline"),
    subText: t("EmailVerificationPage.Subtext"),
    navigate: navigateToHomepage
  }
}
